import { render, staticRenderFns } from "./Brick.container.vue?vue&type=template&id=2706a897&scoped=true&"
import script from "./Brick.container.vue?vue&type=script&lang=js&"
export * from "./Brick.container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706a897",
  null
  
)

export default component.exports